module.exports = __webpack_public_path__ + "static/media/frame4.60565768.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/frame4.png
// module id = 369
// module chunks = 0